import { AnalyticsCards } from "Common/Components/AnalyticsCards/AnalyticsCards";
import { defaultInnerStyle } from "Common/Components/PageContainer/PageContainer";
import { Boxes, PackageCheck, Siren, AlertTriangle } from "lucide-react";
import ReorderLevel from "./ReorderLevelList/ReorderLevel";

const ReorderLevelList = () => {
  const statuses = [
    {
      label: "Total Items",
      icon: <Boxes size={16} />,
      bgColor: "bg-blue-50",
      textColor: "text-blue-600",
      count: 120,
    },
    {
      label: "Normal Stock",
      icon: <PackageCheck size={16} />,
      bgColor: "bg-green-50",
      textColor: "text-green-600",
      count: 35,
    },
    {
      label: "Low Stock",
      icon: <AlertTriangle size={16} />,
      bgColor: "bg-yellow-50",
      textColor: "text-yellow-600",
      count: 50,
    },
    {
      label: "Critical",
      icon: <Siren size={16} />,
      bgColor: "bg-red-50",
      textColor: "text-red-600",
      count: 82,
    },
  ];

  return (
    <div
      className="page-content px-3 mecord-kpi-list-page"
      style={{ "--mecord-table-offset": "360px" } as React.CSSProperties}
    >
      <div className="flex-shrink-0">
        <AnalyticsCards statuses={statuses} />
      </div>

      <div
        className="mecord-list-panel"
        style={{
          ...defaultInnerStyle,
          flex: "1 1 0",
          maxHeight: "100%",
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="d-flex flex-column"
          style={{
            flex: "1 1 auto",
            minHeight: 0,
            maxHeight: "100%",
            overflow: "hidden",
          }}
        >
          <ReorderLevel />
        </div>
      </div>
    </div>
  );
};

export default ReorderLevelList;
